export enum ProfessionGroupType {
    None = 1,
    Safeboard = 2,
    Alliance = 3,
}
